import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../model/authSlice";
import CustomInput from "../../../shared/components/CustomInput";
import s from "../styles.module.css";
import logo from "../../../shared/assets/img/logo.png";
import { toast } from "react-toastify";
const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await dispatch(loginUser(data));

      if (response.type === "auth/loginUser/fulfilled") {
        navigate("/myProperties");
      } else {
        console.error(response.payload);
        toast.error(response.payload);
      }
    } catch (error) {
      toast.error(error);
      console.error("Ошибка при входе:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className={s.loginPage}>
        <form onSubmit={handleSubmit(onSubmit)} className={s.form}>
          <img src={logo} alt="logo" />
          <div className={s.box}>
            <div className={s.inputWrapper}>
              <CustomInput
                name="email"
                label="Логин"
                placeholder="Введите логин"
                type="text"
                error={!!errors.email}
                helperText={errors.email?.message || ""} 
                inputRef={
                  register("email", {
                    required: "Логин обязателен",
                  }).ref
                } 
                {...register("email", {
                  required: "Логин обязателен",
                })}
              />
            </div>
            <div className={s.inputWrapper}>
              <CustomInput
                name="password"
                label="Пароль"
                placeholder="Введите пароль"
                type="password"
                error={!!errors.password} 
                helperText={errors.password?.message || ""} 
                inputRef={
                  register("password", {
                    required: "Пароль обязателен",
                   
                  }).ref
                }
                {...register("password", {
                  required: "Пароль обязателен",
                 
                })}
              />
            </div>
          </div>

          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 10,
              }}
            >
              <div className="loader"></div>
            </div>
          ) : (
            <button type="submit" className={s.btn}>
              Войти
            </button>
          )}
          {/*<div className={s.forgotPassword}>*/}
          {/*  <a href="/forgot-password">Забыли пароль?</a>*/}
          {/*</div>*/}
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
